import { Component } from '@angular/core';

@Component({
    selector: 'app-web-layout',
    standalone: false,
    templateUrl: './web-layout.component.html',
    styleUrl: './web-layout.component.scss',
})
export class WebLayoutComponent {}
